/**
 * Core EmptyState — consistent zero-data display.
 */
import React from 'react';
import { cn } from '@/lib/utils';
import { Inbox } from 'lucide-react';

export interface EmptyStateProps {
  icon?: React.ReactNode;
  title?: string;
  description?: string;
  action?: React.ReactNode;
  className?: string;
}

export const EmptyState: React.FC<EmptyStateProps> = ({ icon, title = 'No data found', description, action, className }) => (
  <div className={cn("flex-1 flex flex-col items-center justify-center text-center p-12 border-2 border-dashed border-gray-200 dark:border-slate-700 rounded-3xl bg-gray-50/50 dark:bg-slate-900/50", className)}>
    <div className="bg-white dark:bg-slate-800 p-4 rounded-full shadow-sm mb-4">
      {icon || <Inbox className="h-8 w-8 text-gray-300 dark:text-slate-500" />}
    </div>
    <h3 className="text-lg font-semibold text-gray-900 dark:text-slate-100">{title}</h3>
    {description && <p className="text-gray-500 dark:text-slate-400 text-sm mt-2 max-w-xs">{description}</p>}
    {action && <div className="mt-6">{action}</div>}
  </div>
);
export default EmptyState;
